const variables = {
  settings: {
    theme: null,
  },
};

export default variables;
